import jsonpack from 'jsonpack';

const getEncodedQueryParams = <T>(data: T): string => {
  const encodedData = jsonpack.pack(data);
  return window.btoa(encodeURIComponent(encodedData));
};

export default getEncodedQueryParams;
